import React, { useState, useEffect, useCallback } from 'react';
import api from '../services/api';
import VendasDashboard from '../components/VendasDashboard';
import VendaCard from '../components/VendaCard';
import FiltroVendas from '../components/FiltroVendas';
import Paginacao from '../components/Paginacao';
import Loading from '../components/Loading';
import ErrorToast from '../components/ErrorToast';
import './Vendas.css';

const Vendas = () => {
  const [vendasData, setVendasData] = useState({ data: [], totalItems: 0 });
  const [summaryData, setSummaryData] = useState(null);
  const [filters, setFilters] = useState({});
  const [page, setPage] = useState(1);
  const [pageSize] = useState(10);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const fetchVendas = useCallback(async () => {
    setIsLoading(true);
    setError('');
    try {
      const response = await api.get('/vendas', {
        params: { ...filters, page, pageSize },
      });
      setVendasData({ data: response.data.data, totalItems: response.data.totalItems });
      setSummaryData(response.data.summary);
    } catch (err) {
      setError(err.response?.data?.error || 'Erro ao buscar vendas.');
    } finally {
      setIsLoading(false);
    }
  }, [filters, page, pageSize]);

  useEffect(() => {
    fetchVendas();
  }, [fetchVendas]);

  const handleSearch = (newFilters) => {
    setFilters(newFilters);
    setPage(1);
  };

  return (
    <div className="page-container">
      <h1 className="page-title">Vendas de Mercado</h1>
      <FiltroVendas onSearch={handleSearch} />
      {error && <ErrorToast message={error} onClose={() => setError('')} />}
      <VendasDashboard summary={summaryData} total_vendas={vendasData.totalItems} />
      {isLoading ? (
        <Loading />
      ) : (
        <>
          <div className="vendas-list">
            {vendasData.data.map(venda => (
              <VendaCard key={venda.contribuinte} venda={venda} />
            ))}
          </div>
          <Paginacao
            totalItens={vendasData.totalItems}
            itensPorPagina={pageSize}
            paginaAtual={page}
            setPaginaAtual={setPage}
          />
        </>
      )}
    </div>
  );
};

export default Vendas;
